/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { Select, FormControl } from "@mui/material";
import { DataField } from "@iventis/domain-model/model/dataField";
import { Content } from "@iventis/translations/content/typed-content";
import { StyledMenuItem, StyledItemSelect } from "@iventis/components";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { FilterType } from "./filter-rules";

export type ScheduleViewBySelection = {
    filterType: FilterType;
    label: string;
    dataField?: DataField;
};

export const ScheduleViewBySelector: React.FC<{
    onChange: (selection: ScheduleViewBySelection) => void;
    options: ScheduleViewBySelection[];
    selection: ScheduleViewBySelection;
    disabled?: boolean;
    className?: string;
}> = ({ onChange, selection, options, className, disabled }) => {
    const translate = useIventisTranslate();

    const handleOnChange = (value: string) => {
        onChange(options.find((option) => option.label === value));
    };

    return (
        <>
            <FormControl variant="outlined" className={className}>
                <Select
                    data-cy="view-by-selector"
                    name="view-by-selector"
                    input={<StyledItemSelect $verticalPadding="8px" />}
                    value={selection.label}
                    style={{ height: "44px" }}
                    disabled={disabled}
                    renderValue={(label: string) => `${translate(Content.schedule.view_by)}: ${translate(label)}`}
                    onChange={(e) => handleOnChange(e.target.value as string)}
                >
                    {options.map((option) => (
                        <StyledMenuItem data-cy={option.filterType} key={`${option.filterType}${option.dataField?.id || ""}`} value={option.label}>
                            {option.label}
                        </StyledMenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
};

export const generateScheduleViewByOptions: (dataFieldOptions: DataField[]) => ScheduleViewBySelection[] = (dataFieldOptions) => [
    { filterType: FilterType.DayVenue, label: Content.schedule.day_venue },
    ...dataFieldOptions.map((dataField) => ({ filterType: FilterType.DayDataField, dataField, label: Content.schedule2.data_fields.view_by_day_label[dataField.name] })),
    { filterType: FilterType.Venue, label: Content.schedule.venue },
    ...dataFieldOptions.map((dataField) => ({ filterType: FilterType.DataField, dataField, label: dataField.name })),
    { filterType: FilterType.Summary, label: Content.schedule.summary },
    { filterType: FilterType.VenueRunSheet, label: Content.schedule.DCAS },
];
